import React, { useEffect, useState } from "react";
import api, { formatApiError, API } from "../../lib/api";
import { Window, Loading, EmptyState } from "../../components/VB";
import { toast } from "sonner";
import { Download, FileSpreadsheet } from "lucide-react";

const REPORTS = [
  { key: "absensi", label: "Laporan Absensi" },
  { key: "izin", label: "Laporan Izin" },
  { key: "poin", label: "Laporan Poin Kinerja" },
  { key: "gaji", label: "Laporan Gaji" },
];

export default function Laporan() {
  const [tipe, setTipe] = useState("absensi");
  const [bulan, setBulan] = useState(new Date().toISOString().slice(0, 7));
  const [empId, setEmpId] = useState("");
  const [divId, setDivId] = useState("");
  const [status, setStatus] = useState("");
  const [emps, setEmps] = useState([]);
  const [divs, setDivs] = useState([]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const [e, d] = await Promise.all([api.get("/employees"), api.get("/divisi")]);
        setEmps(e.data); setDivs(d.data);
      } catch (err) {}
    })();
  }, []);

  const load = async () => {
    setLoading(true);
    try {
      const params = { bulan };
      if (empId) params.employee_id = empId;
      if (divId) params.divisi_id = divId;
      if (status && tipe !== "poin" && tipe !== "gaji") params.status = status;
      const { data } = await api.get(`/reports/${tipe}`, { params });
      setData(data);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setLoading(false);
  };

  const download = (format) => {
    const params = new URLSearchParams({ bulan, format });
    if (empId) params.append("employee_id", empId);
    if (divId) params.append("divisi_id", divId);
    if (status) params.append("status", status);
    const token = localStorage.getItem("access_token");
    const url = `${API}/reports/${tipe}?${params}`;
    // Fetch then download as blob to send Authorization header
    fetch(url, { credentials: "include", headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then((r) => r.blob())
      .then((blob) => {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = `laporan_${tipe}.${format}`;
        a.click();
      })
      .catch((e) => toast.error("Gagal download"));
  };

  return (
    <Window title="Laporan">
      <div style={{ display: "flex", gap: 6, marginBottom: 10, flexWrap: "wrap" }}>
        <select className="vb-select" style={{ width: 200 }} value={tipe} onChange={(e) => setTipe(e.target.value)} data-testid="lap-tipe">
          {REPORTS.map((r) => <option key={r.key} value={r.key}>{r.label}</option>)}
        </select>
        <input type="month" className="vb-input" style={{ width: 160 }} value={bulan} onChange={(e) => setBulan(e.target.value)} data-testid="lap-bulan" />
        <select className="vb-select" style={{ width: 200 }} value={empId} onChange={(e) => setEmpId(e.target.value)} data-testid="lap-emp">
          <option value="">Semua Karyawan</option>
          {emps.map((e) => <option key={e.id} value={e.id}>{e.nama_lengkap}</option>)}
        </select>
        <select className="vb-select" style={{ width: 160 }} value={divId} onChange={(e) => setDivId(e.target.value)} data-testid="lap-divisi">
          <option value="">Semua Divisi</option>
          {divs.map((d) => <option key={d.id} value={d.id}>{d.nama}</option>)}
        </select>
        {(tipe === "absensi" || tipe === "izin") && (
          <select className="vb-select" style={{ width: 160 }} value={status} onChange={(e) => setStatus(e.target.value)} data-testid="lap-status">
            <option value="">Semua Status</option>
            {tipe === "absensi" ? ["Hadir", "Tidak Hadir", "Izin", "Sakit", "Terlambat"].map((s) => <option key={s}>{s}</option>)
              : ["Pending", "Approved", "Rejected"].map((s) => <option key={s}>{s}</option>)}
          </select>
        )}
        <button className="vb-btn-primary" onClick={load} data-testid="lap-tampilkan">Tampilkan</button>
        <button className="vb-btn" onClick={() => download("csv")} data-testid="lap-csv"><Download className="w-3 h-3 inline mr-1" />CSV</button>
        <button className="vb-btn" onClick={() => download("xlsx")} data-testid="lap-xlsx"><FileSpreadsheet className="w-3 h-3 inline mr-1" />Excel</button>
      </div>

      {data?.summary && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 8, marginBottom: 10 }}>
          {Object.entries(data.summary).map(([k, v]) => (
            <div key={k} className="vb-statcard">
              <div className="vb-statcard-label">{k}</div>
              <div className="vb-statcard-value">{v}</div>
            </div>
          ))}
        </div>
      )}

      {loading ? <Loading /> : !data ? <EmptyState message="Klik 'Tampilkan' untuk memuat laporan" /> :
        (data.rows?.length === 0 ? <EmptyState /> : (
          <div style={{ overflowX: "auto" }}>
            <table className="vb-table">
              <thead><tr>{Object.keys(data.rows[0] || {}).map((k) => <th key={k}>{k}</th>)}</tr></thead>
              <tbody>
                {data.rows.map((r, i) => (
                  <tr key={i}>{Object.values(r).map((v, j) => <td key={j}>{typeof v === "number" ? v.toLocaleString("id-ID") : v}</td>)}</tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
    </Window>
  );
}
